import { useState, useCallback } from "react";

export default function useModal() {
  const [isOpen, setisOpen] = useState(false);

  const toggle = useCallback(() => {
    requestAnimationFrame(() => {
      setisOpen(prev => !prev);
    });
  }, []);

  return {
    isOpen,
    toggle
  };
}
